import { Col, Flex, Row } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import MoneyIcon from "../../../assets/icons/MoneyIcon";
import TicketIcon from "../../../assets/icons/TicketIcon";
import TitleBar from "../../../components/common/TitleBar";
import {
  useGetDueAmountsQuery,
  useGetSummeryQuery,
} from "../../../features/Dashboard/dashboard.api";
import SidebarLayout from "../../../layouts/SidebarLayout";
import Calendar from "./_components/Calendar";
import MonthlyPaymentsChart from "./_components/MonthlyPayments";
import TopFiveVendor from "./_components/TopFiveVendor";
export const formatNumber = (num: number) => {
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num.toString();
};

const ManageInvoice = () => {
  const [filter] = useState<{ year: number; month: number }>({
    year: dayjs().year(),
    month: dayjs().month() + 1, // month is 0-indexed
  });

  const { data: summery } = useGetSummeryQuery({
    params: {},
  });
  const { data: dueAmounts } = useGetDueAmountsQuery({});

  return (
    <SidebarLayout title="Dashboard">
      <TitleBar
        title="Dashboard Overview"
        subTitle="Monitor your vendor management operations at a glance"
      >
        {/* <DatePicker
          allowClear={false}
          picker="month"
          className="bg-date-picker"
          size="middle"
          style={{ width: 150 }}
          format="MMM YYYY"
          value={dayjs(`${filter?.year}-${filter?.month}-01`)}
          onChange={(date: dayjs.Dayjs | null) => {
            if (date) {
              setFilter({ year: date.year(), month: date.month() + 1 }); // month is 0-indexed
            }
          }}
        /> */}
      </TitleBar>

      {/* ------ Dashboard sates ------ */}
      <Row gutter={8}>
        <Col span={8}>
          <Flex
            align="center"
            gap={16}
            className="p-4 bg-theme-error-25 border border-theme-error-50 rounded-xl"
          >
            <Flex
              align="center"
              justify="center"
              className="size-[42px] rounded-lg bg-theme-error-500 text-white"
            >
              <MoneyIcon />
            </Flex>
            <div>
              <span className="text-[15px] text-theme-error-500 font-medium">
                Overdue (BDT)
              </span>
              <h4 className="text-xl text-theme-error-500 font-semibold">
                {formatNumber(dueAmounts?.data?.overdue_amount || 0)}
              </h4>
              <span className="text-sm text-theme-error-300">
                Till Yesterday -{" "}
                {dayjs().subtract(1, "day").format("D MMMM, YYYY")}
              </span>
            </div>
          </Flex>
        </Col>
        <Col span={8}>
          <Flex
            align="center"
            gap={16}
            className="p-4 bg-theme-orange-25 border border-theme-orange-50 rounded-xl"
          >
            <Flex
              align="center"
              justify="center"
              className="size-[42px] rounded-lg bg-theme-orange-500 text-white"
            >
              <MoneyIcon />
            </Flex>
            <div>
              <span className="text-[15px] text-theme-orange-500 font-medium">
                Due Amount (BDT)
              </span>
              <h4 className="text-xl text-theme-orange-500 font-semibold">
                {formatNumber(dueAmounts?.data?.today_due_amount || 0)}
              </h4>
              <span className="text-sm text-theme-orange-400">
                {dayjs().format("D MMMM, YYYY")}
              </span>
            </div>
          </Flex>
        </Col>
        <Col span={8}>
          <Flex
            align="center"
            gap={16}
            className="p-4 bg-theme-indigo-25 border border-theme-indigo-50 rounded-xl"
          >
            <Flex
              align="center"
              justify="center"
              className="size-[42px] rounded-lg bg-theme-indigo-500 text-white"
            >
              <MoneyIcon />
            </Flex>
            <div>
              <span className="text-[15px] text-theme-indigo-500 font-medium">
                Due of Next 7 Days (BDT)
              </span>
              <h4 className="text-xl text-theme-indigo-500 font-semibold">
                {formatNumber(dueAmounts?.data?.next_7_days_due_amount || 0)}
              </h4>
              <span className="text-sm text-theme-indigo-500">
                {dayjs().format("D MMMM, YYYY")} -{" "}
                {dayjs().add(7, "day").format("D MMMM, YYYY")}
              </span>
            </div>
          </Flex>
        </Col>
      </Row>

      {/* ------ Dashboard chart and others ------ */}
      <Row gutter={24} className="my-6">
        <Col span={16}>
          {/* Chart States */}
          <Row gutter={20} className="mb-5">
            <Col span={8}>
              <Flex
                align="center"
                justify="space-between"
                className="p-4 rounded-xl border border-theme-indigo-50"
              >
                <div>
                  <span className="text-sm text-theme-gray-600">
                    Active Vendors
                  </span>
                  <h4 className="text-xl text-theme-gray-900 font-semibold">
                    {summery?.data?.active_vendors_count}
                  </h4>
                </div>
                <Flex
                  align="center"
                  justify="center"
                  className="size-8 rounded-lg bg-theme-indigo-25 text-theme-indigo-500"
                >
                  <TicketIcon />
                </Flex>
              </Flex>
            </Col>
            <Col span={8}>
              <Flex
                align="center"
                justify="space-between"
                className="p-4 rounded-xl border border-theme-indigo-50"
              >
                <div>
                  <span className="text-sm text-theme-gray-600">
                    Total Paid
                  </span>
                  <h4 className="text-xl text-theme-gray-900 font-semibold">
                    {formatNumber(summery?.data?.total_paid_amount || 0)}
                  </h4>
                </div>
                <Flex
                  align="center"
                  justify="center"
                  className="size-8 rounded-lg bg-theme-sky-50 text-theme-sky-500"
                >
                  <TicketIcon />
                </Flex>
              </Flex>
            </Col>
            <Col span={8}>
              <Flex
                align="center"
                justify="space-between"
                className="p-4 rounded-xl border border-theme-indigo-50"
              >
                <div>
                  <span className="text-sm text-theme-gray-600">
                    Submitted Invoices
                  </span>
                  <h4 className="text-xl text-theme-gray-900 font-semibold">
                    {summery?.data?.total_invoices_count}
                  </h4>
                </div>
                <Flex
                  align="center"
                  justify="center"
                  className="size-8 rounded-lg bg-theme-error-25 text-theme-error-500"
                >
                  <TicketIcon />
                </Flex>
              </Flex>
            </Col>
          </Row>
          {/* Chart */}
          <MonthlyPaymentsChart />
        </Col>
        <Col span={8}>
          <Calendar filter={filter} />
        </Col>
      </Row>

      {/* ------ Top Five Vendor ------ */}
      <TopFiveVendor filter={filter} />
    </SidebarLayout>
  );
};

export default ManageInvoice;
